"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriorityTasksSortDTO = exports.getPriorityTasksFilterDTO = exports.priorityTasksFieldsToFilterMap = exports.createMultiSelectStringFilter = exports.createPriorityFilter = exports.createStatusFilter = exports.getNormalizedPriorityTasksSort = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const filter_1 = require("../filter");
const client_utils_1 = require("../../../common/table-filter/client.utils");
const getNormalizedPriorityTasksSort = (tableSort) => {
    if (!tableSort) {
        return null;
    }
    return Object.assign(Object.assign({}, tableSort), { key: normalizeSortKey(tableSort.key) });
};
exports.getNormalizedPriorityTasksSort = getNormalizedPriorityTasksSort;
const createMultiSelectValueFilter = (filter) => {
    var _a, _b;
    const list = (_a = filter.list) !== null && _a !== void 0 ? _a : [];
    const excludedValues = (_b = filter.excludedValues) !== null && _b !== void 0 ? _b : [];
    if (filter.selectAll) {
        if (filter.operator === String(ui_components_1.ListFilterOperatorTypes.IsNot)) {
            return { in: excludedValues };
        }
        return excludedValues.length ? { notIn: excludedValues } : {};
    }
    if (excludedValues.length) {
        return { notIn: excludedValues };
    }
    return { in: list };
};
const createStatusFilter = (filter) => (createMultiSelectValueFilter(filter));
exports.createStatusFilter = createStatusFilter;
const createPriorityFilter = (filter) => (createMultiSelectValueFilter(filter));
exports.createPriorityFilter = createPriorityFilter;
const createMultiSelectStringFilter = (filter) => {
    const valueFilter = createMultiSelectValueFilter(filter);
    return Object.keys(valueFilter).length ? Object.assign({ mode: graphql_1.StringFilterMode.Insensitive }, valueFilter) : {};
};
exports.createMultiSelectStringFilter = createMultiSelectStringFilter;
exports.priorityTasksFieldsToFilterMap = {
    [filter_1.HLQATasksFilterFields.Status]: exports.createStatusFilter,
    [filter_1.HLQATasksFilterFields.EscalationReason]: client_utils_1.createStringFilter,
    [filter_1.HLQATasksFilterFields.Priority]: exports.createPriorityFilter,
    [filter_1.HLQATasksFilterFields.L1NodeTitle]: exports.createMultiSelectStringFilter,
    [filter_1.HLQATasksFilterFields.Task]: client_utils_1.createStringFilter,
    [filter_1.HLQATasksFilterFields.TerminalNode]: exports.createMultiSelectStringFilter,
    [filter_1.HLQATasksFilterFields.Attribute]: exports.createMultiSelectStringFilter,
    [filter_1.HLQATasksFilterFields.TotalProducts]: client_utils_1.createIntFilter,
    [filter_1.HLQATasksFilterFields.AssignedTo]: exports.createMultiSelectStringFilter,
    [filter_1.HLQATasksFilterFields.ReviewedBy]: exports.createMultiSelectStringFilter,
    [filter_1.HLQATasksFilterFields.ProductsReviewed]: client_utils_1.createIntFilter,
    [filter_1.HLQATasksFilterFields.PercentReviewed]: client_utils_1.createFloatFilter,
    [filter_1.HLQATasksFilterFields.CorrectionsCount]: client_utils_1.createIntFilter,
    [filter_1.HLQATasksFilterFields.CorrectionsPercentage]: client_utils_1.createFloatFilter,
    [filter_1.HLQATasksFilterFields.TotalCorrectionsPercentage]: client_utils_1.createFloatFilter,
    [filter_1.HLQATasksFilterFields.TaskCount]: client_utils_1.createIntFilter,
    [filter_1.HLQATasksFilterFields.InstructionsUpdatedAt]: client_utils_1.createDateTimeFilter,
    [filter_1.HLQATasksFilterFields.LastReviewedAt]: client_utils_1.createDateTimeFilter,
    [filter_1.HLQATasksFilterFields.NotApplicable]: client_utils_1.createIntFilter,
    [filter_1.HLQATasksFilterFields.Unknown]: client_utils_1.createIntFilter,
};
const isFieldSupportedForMode = (field) => field !== filter_1.HLQATasksFilterFields.Task;
const isPlainObject = (value) => (value != null
    && typeof value === 'object'
    && !Array.isArray(value));
const isEmptyFieldFilter = (value) => isPlainObject(value) && Object.keys(value).length === 0;
const mergeArrayValues = (left, right) => {
    if (!left && !right) {
        return undefined;
    }
    return Array.from(new Set([...(left !== null && left !== void 0 ? left : []), ...(right !== null && right !== void 0 ? right : [])]));
};
const getArrayFilterValue = (filter, key) => (Array.isArray(filter[key]) ? filter[key] : undefined);
const mergePriorityTasksFieldFilter = (existingFilter, mappedFilter) => {
    if (!isPlainObject(existingFilter) || !isPlainObject(mappedFilter)) {
        return mappedFilter;
    }
    const mergedFilter = Object.assign(Object.assign({}, existingFilter), mappedFilter);
    const mergedIn = mergeArrayValues(getArrayFilterValue(existingFilter, 'in'), getArrayFilterValue(mappedFilter, 'in'));
    const mergedNotIn = mergeArrayValues(getArrayFilterValue(existingFilter, 'notIn'), getArrayFilterValue(mappedFilter, 'notIn'));
    return Object.assign(Object.assign(Object.assign({}, mergedFilter), mergedIn && { in: mergedIn }), mergedNotIn && { notIn: mergedNotIn });
};
const getPriorityTasksFilterDTO = (tableFilter) => {
    const { items } = tableFilter;
    if (!items.length) {
        return null;
    }
    const result = items.reduce((acc, { field, filter }) => {
        const columnId = field;
        if (!isFieldSupportedForMode(columnId)) {
            return acc;
        }
        const mapToFilter = exports.priorityTasksFieldsToFilterMap[columnId];
        if (!mapToFilter) {
            return acc;
        }
        const mappedFilter = mapToFilter(filter);
        if (isEmptyFieldFilter(mappedFilter)) {
            return acc;
        }
        const existingFilter = acc[columnId];
        if (existingFilter) {
            return Object.assign(Object.assign({}, acc), { [columnId]: mergePriorityTasksFieldFilter(existingFilter, mappedFilter) });
        }
        return Object.assign(Object.assign({}, acc), { [columnId]: mappedFilter });
    }, {});
    if (tableFilter.logicOperator === 'or' && Object.keys(result).length > 0) {
        result.filterStrategy = graphql_1.FilterStrategy.Or;
    }
    return Object.keys(result).length ? result : null;
};
exports.getPriorityTasksFilterDTO = getPriorityTasksFilterDTO;
const TASK_SORT_KEY = filter_1.HLQATasksFilterFields.Task;
const TERMINAL_NODE_SORT_KEY = filter_1.HLQATasksFilterFields.TerminalNode;
const normalizeSortKey = (key) => {
    if (key === TASK_SORT_KEY) {
        return TERMINAL_NODE_SORT_KEY;
    }
    return key;
};
const getPriorityTasksSortDTO = (tableSort) => {
    var _a;
    const normalized = (_a = (0, exports.getNormalizedPriorityTasksSort)(tableSort)) !== null && _a !== void 0 ? _a : tableSort;
    const primarySortDirection = normalized.direction === 1 /* SortDirection.Descending */ ? graphql_1.OrderBy.Desc : graphql_1.OrderBy.Asc;
    const primarySort = {
        [normalized.key]: primarySortDirection,
    };
    if (normalized.key === 'task') {
        return [primarySort];
    }
    // Add a deterministic tie-breaker so cursor pagination does not overlap when
    // many rows share the same primary sort value (e.g. nodeTitle).
    return [
        primarySort,
        { task: graphql_1.OrderBy.Asc },
    ];
};
exports.getPriorityTasksSortDTO = getPriorityTasksSortDTO;
